import React, { useEffect } from 'react';
import './SharedPages.css';
import { ArrowRight } from 'lucide-react';

function JoinPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper" style={{ background: 'var(--bg-secondary)' }}>
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">Nous rejoindre</h1>
          <p className="page-subtitle">
            CrousRadar grandit vite. Tu veux participer à l'aventure et impacter la vie de milliers d'étudiants ?
          </p>
        </div>

        <div className="page-content">
          <p>
            Que tu sois développeur, designer, ou simplement ultra-motivé pour devenir Ambassadeur CrousRadar sur ton campus, il y a forcément une place pour toi dans l'équipe.
          </p>

          <h2>Ambassadeurs Campus</h2>
          <p>
            Tu connais ton Resto U comme ta poche et tu souhaites motiver les autres étudiants à utiliser l'application pour le bien commun ? Deviens Ambassadeur. Tu auras accès à des fonctionnalités exclusives, des goodies, et la reconnaissance éternelle de ton campus !
          </p>

          <div style={{ marginTop: '40px', textAlign: 'center' }}>
            <a href="mailto:contact@crousradar.fr" className="btn-brutal primary">
              Je postule ! <ArrowRight size={20} />
            </a>
          </div>

          <h2 style={{ marginTop: '80px' }}>Profils Tech & Produit</h2>
          <div className="brutal-info-grid">
            <div className="brutal-info-card">
              <h3>Dev React / React Native</h3>
              <p>Tu aimes coder des apps fluides ? Viens optimiser nos jeux et notre interface.</p>
            </div>
            <div className="brutal-info-card">
              <h3>Growth Marketing</h3>
              <p>Aide-nous à conquérir les campus de France plus vite que notre ombre.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JoinPage;
